import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import SelectGoalTree from './SelectGoalTree';
import actions from './SelectGoalTree.actions';
import { getOffers, getGoals, getGoalActions } from './SelectGoalTree.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    offers: getOffers,
    goals: getGoals,
    goalActions: getGoalActions
});

const Connected = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            loadingOffers: state.selectGoalActions.loadingOffers,
            loadingGoals: state.selectGoalActions.loadingGoals,
            loadingGoalActions: state.selectGoalActions.loadingGoalActions
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            getListOffers: actions.getListOffers,
            getListGoals: actions.getListGoals,
            getListGoalActions: actions.getListGoalActions
        };
    }
)(SelectGoalTree);

export default function SelectGoalTreeContainer(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return (
        <Connected
            {...props}
            location={{ pathname: location.pathname, query: location.search }}
            navigate={navigate}
            params={params}
        />
    );
}
